import { InputContainer, StyledInputLabel } from 'Components/Inputs/StyledInputLabel'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { StyledSwitch } from 'Components/Inputs/Switch/StyledSwitch'

type ControlledSwitchProps<T extends FieldValues> = {
  label: string
  name: Path<T>
  control: Control<T>
  defaultChecked?: boolean
  disabled?: boolean
}

export const ControlledSwitch = <T extends FieldValues>({
  label,
  name,
  control,
  disabled,
  defaultChecked = false
}: ControlledSwitchProps<T>) => (
  <InputContainer>
    <StyledInputLabel>{label}</StyledInputLabel>
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <StyledSwitch
          onCheckedChange={() => {
            onChange(!value)
          }}
          disabled={disabled}
          defaultChecked={defaultChecked}
          checked={value}
        />
      )}
    />
  </InputContainer>
)
